import React from 'react'
// eslint-disable-next-line import/named
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
import { COLORS } from '../styles/variables'

export const IconJoin: React.FC<SvgIconProps> = ({sx}) => (
  <SvgIcon
    viewBox="0 0 34 18"
    sx={{
      color: COLORS.CERULEAN,
      width: 34, 
      height: 18,
      ...sx,
    }}
  >
    <path
      d="M8.41155 11.875C7.84537 11.7206 7.22772 11.6177 6.61008 11.6177C3.93361 11.6177 1.72036 13.1103 0.588012 15.0662C-0.132577 16.3015 0.742426 17.8456 2.1836 17.8456H7.53654C7.48507 17.7941 7.43361 17.6912 7.38213 17.6397C6.61008 16.3015 6.61008 14.7059 7.38213 13.3677C7.69096 12.8015 7.99978 12.3383 8.41155 11.875Z"
      stroke="none"
      fill="currentColor"
    />
    <path
      d="M32.9632 15.0662C31.8308 13.1103 29.6176 11.6177 26.9411 11.6177C26.3235 11.6177 25.7058 11.7206 25.1396 11.875C25.4999 12.3383 25.8602 12.8015 26.1691 13.3677C26.9411 14.7059 26.9411 16.3015 26.1691 17.6397C26.1176 17.7427 26.0661 17.7941 26.0147 17.8456H31.3676C32.8088 17.8456 33.6838 16.3015 32.9632 15.0662Z"
      stroke="none"
      fill="currentColor"
    />
    <path
      d="M16.7499 9.81592C13.3528 9.81592 10.4705 11.7718 8.97784 14.2939C8.05137 15.8894 9.18373 17.8453 11.0367 17.8453H22.4631C24.3161 17.8453 25.4484 15.838 24.522 14.2939C23.0808 11.7718 20.1984 9.81592 16.7499 9.81592ZM23.0808 15.838C23.0293 15.9409 22.8234 16.1983 22.4631 16.1983H11.0367C10.6764 16.1983 10.522 15.9924 10.419 15.838C10.3675 15.735 10.2131 15.4262 10.419 15.1174C11.7058 12.9042 14.1764 11.5144 16.6984 11.5144C19.2205 11.5144 21.7425 12.9556 22.9778 15.1174C23.2352 15.4262 23.1323 15.735 23.0808 15.838Z"
      stroke="none"
      fill="currentColor"
    />
    <path
      d="M6.61 10.3309C8.28716 10.3309 9.64677 8.97125 9.64677 7.29409C9.64677 5.61693 8.28716 4.25732 6.61 4.25732C4.93284 4.25732 3.57324 5.61693 3.57324 7.29409C3.57324 8.97125 4.93284 10.3309 6.61 10.3309Z"
      stroke="none"
      fill="currentColor"
    />
    <path
      d="M26.9411 10.3309C28.6182 10.3309 29.9778 8.97125 29.9778 7.29409C29.9778 5.61693 28.6182 4.25732 26.9411 4.25732C25.2639 4.25732 23.9043 5.61693 23.9043 7.29409C23.9043 8.97125 25.2639 10.3309 26.9411 10.3309Z"
      stroke="none"
      fill="currentColor"
    />
    <path
      d="M15.6687 8.01482C16.029 8.11776 16.3893 8.16923 16.8011 8.16923C17.2128 8.16923 17.5731 8.11776 17.9334 8.01482C19.529 7.55159 20.7128 6.05894 20.7128 4.25747C20.7128 2.0957 18.9628 0.345703 16.8011 0.345703C14.6393 0.345703 12.8893 2.0957 12.8893 4.25747C12.8378 6.00747 14.0217 7.50012 15.6687 8.01482ZM16.7496 1.88982C18.0364 1.88982 19.1172 2.9707 19.1172 4.25747C19.1172 5.54423 18.0364 6.62511 16.7496 6.62511C15.4628 6.62511 14.382 5.54423 14.382 4.25747C14.382 2.9707 15.4628 1.88982 16.7496 1.88982Z"
      stroke="none"
      fill="currentColor"
    />
  </SvgIcon>
)
